// Get images
// https://www.flickr.com/photos/195241587@N06/with/51944722029/

const CertificationsGallery = [
    {
        id: 1,
        imageSrc: "https://live.staticflickr.com/65535/52224220301_b52018d3bc_b.jpg",
        caption: "Letter of Internship 2021",
        desc: "Invictus360",
        githubLink: "https://github.com/abduldaim-ad/html_web_page",
    },
    {
        id: 2,
        imageSrc: "https://live.staticflickr.com/65535/52224495139_930f534063_b.jpg",
        caption: "Academic Performance 2021",
        desc: "Air University",
        githubLink: "https://github.com/abduldaim-ad/HTML",
    },
    {
        id: 3,
        imageSrc: "https://digital-badges-og-image.gitnation.vercel.app/certificate.png?data=ab59a01d6b58801e2a0979fa70cba1f91453be01ce68e5365a83f834a14b7479b2a3574f0f68ad7e3e0abe95b66ea4cc20411d3914bffb3c96ece34949090303d0f94f6e8e7c931129f50bf30be3745e7c88c8bd56b49798d781da067a32263dcf8bab5a04a4fe2da9fbae7e058e16dfe4a559100a8f40fc2daf496e57326221acd20c013f6e636d84b42cb7c6d8951586d91d3a9e493675e38d8633094bdb89bdb45f2bfdb053e08208747f49cc8b2c8f67031577b77c43c2b569e7d040128978175dc19599d9e3c463691d0f3c19cdbdc816b5dbbb0ce92105b666f6ef34b2052ce40ba1195ccb34535c060a7d17eeaf47bd3931188e7532706dfb3b855cf0511b4ad06132c8b210fcb3562b94c7f79acc993d2841f867671df34a83027d367bb23e0a1f5c11bef04ab77e1d7d7b1428b867825e1cec60222c3a9691636a0e847136a0266a81c88fd203ae6cdcb490e5ac72d5c7fdfe6e7787b711bf290ba3d1c7660e86f7591b9d8d523b640a670a4fe88317cf6eb2a60dc7bd5502399fc185c362f62d6a7049e485f605ec4540b2ddde57b0330255619c53ed786fd7e71089dd2968de1d02b98ce91d",
        caption: "React Summit Participation 2022",
        desc: "GitNation",
        githubLink: "https://github.com/abduldaim-ad/html-css_practice_website",
    },
    {
        id: 4,
        imageSrc: "https://live.staticflickr.com/65535/52224237308_f2d1c61316_b.jpg",
        caption: "Internship Completion 2022",
        desc: "SayabiDevs",
        githubLink: "https://github.com/abduldaim-ad/Search_Bar_Filter_Table",
    },
    {
        id: 5,
        imageSrc: "https://live.staticflickr.com/65535/52223219387_eb443552a5_b.jpg",
        caption: "Certificate of Appreciation 2022",
        desc: "SayabiDevs",
        githubLink: "https://github.com/abduldaim-ad/ReactJS_Practice",
    },
    {
        id: 6,
        imageSrc: "https://live.staticflickr.com/65535/52510289126_fd792b2b7a_b.jpg",
        caption: "Certificate of Attendance 2022",
        desc: "AWS",
        githubLink: "https://github.com/abduldaim-ad/ReactJS_Practice",
    },
    {
        id: 7,
        imageSrc: "https://live.staticflickr.com/65535/52510289881_553d711663_b.jpg",
        caption: "Certificate of Attendance 2022",
        desc: "AWS",
        githubLink: "https://github.com/abduldaim-ad/ReactJS_Practice",
    },
    {
        id: 8,
        imageSrc: "https://live.staticflickr.com/65535/52510565564_669273127c_o.png",
        caption: "Certificate of Participation 2022",
        desc: "PSEB",
        githubLink: "https://github.com/abduldaim-ad/ReactJS_Practice",
    },

];

export default CertificationsGallery.reverse();